import React, { Component } from 'react';
import './Phone.css'

class Phone extends Component{
    render(){
        return(
            <div>
                <form  onSubmit = {this.props.submit}>
                    <label for = "number" className = "pLabel">Phone Number: </label>
                    <input className="number" type = "tel" name = "number" defaultValue = {this.props.number}></input>
                    <select name = "carrier" className = "carrier">
                        
                        {this.props.carrier === "select" ? <option value = "select" selected>Select a Carrier</option> : <option value = "select">Select a Carrier</option>}
                        {this.props.carrier === "txt.att.net" ? <option value = "txt.att.net" selected> AT&T</option> : <option value = "txt.att.net"> AT&T</option>}
                        {this.props.carrier === "messaging.sprintpcs.com" ? <option value = "messaging.sprintpcs.com" selected> Sprint</option> : <option value = "messaging.sprintpcs.com"> Sprint</option>}
                        {this.props.carrier === "tomail.net" ?  <option value = "tmomail.net" selected>T-Mobile</option> :  <option value = "tmomail.net">T-Mobile</option>}
                        {this.props.carrier === "email.uscc.net" ?   <option value = "email.uscc.net" selected>US Cellular</option> :   <option value = "email.uscc.net">US Cellular</option>}
                        {this.props.carrier === "vtext.com" ?   <option value = "vtext.com" selected>Verizon</option> :  <option value = "vtext.com">Verizon</option>}
                        {this.props.carrier === "vmobl.com" ?      <option value = "vmobl.com" selected>Virgin Mobile</option> :     <option value = "vmobl.com">Virgin Mobile</option>}
                     
                    </select>

    
                    <br/>
                    <button className="button" type = "submit">Submit</button>
                    <br/>
                    <br/>
                </form>
            </div>
        )
    }


}

export default Phone;


// WEBPACK FOOTER //
// ./src/Phone.js